module.exports = __webpack_public_path__ + "static/graphik-regular-d9d10bc145390df8827474c470720d19.woff";